import GamePiece from '../GamePiece';
import styled from 'styled-components';
import { RACK } from '../../constants';

const RackContainer = styled.div`
  display: flex;
  justify-content: center;
  border: 8px inset #ccc;
  margin: 5px;
  padding: 4px 0;
  height: 115px;
`;

const Rack = ({
  color,
  pieces,
  handler,
  handleMouseEnter,
  handleMouseLeave,
}) => (
  <RackContainer>
    {pieces
      .filter((piece) => piece.color === color && piece.currentPos === RACK)
      .map((piece) => (
        <GamePiece
          clickHandler={handler}
          key={piece.id}
          id={piece.id}
          color={piece.color}
          atLastPosition={false}
          inEnteringSpace={false}
          moveSet={piece.moveSet}
          handleMouseEnter={handleMouseEnter}
          handleMouseLeave={handleMouseLeave}
        />
      ))}
  </RackContainer>
);

export default Rack;
